module.exports = __webpack_public_path__ + "img/82.f2c522e2.jpg";